export default "__VITE_ASSET__541d5227__"